import React, { createContext, useState, useContext } from 'react';
import {jwtDecode} from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [userRole, setUserRole] = useState(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            return decodedToken.role;
        }
        return null;
    });
    const [username, setUsername] = useState(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            return decodedToken.unique_name;
        }
        return null;
    }); 
    const [email, setEmail] = useState(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            return decodedToken.email;
        }
        return null;
    });

    const login = (token) => {
        localStorage.setItem('token', token);
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role);
        setUsername(decodedToken.unique_name); 
        setEmail(decodedToken.email);
        setIsLoggedIn(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUserRole(null);
    };

    const setIsCollapsedValue = (value) => {
        setIsCollapsed(value);
        localStorage.setItem('isCollapsed', value);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, userRole, username, email, login, logout, isCollapsed, setIsCollapsedValue }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
